import React from "react";
import gettext from "../../../../shared/utils/gettext";
import Icon from "../../../../shared/icons/Icon";

function DownloadButton({ children }: any) {
  return (
    <div className="dropdown float-right">
      <button
        className="btn btn-outline-smoke dropdown-toggle"
        data-toggle="dropdown"
        id="downloadOptions"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <Icon icon={"download"} className={"fa-fw mr-2"} />
        {gettext("download")}
      </button>
      <ul className="dropdown-menu" aria-labelledby="downloadOptions">
        {children}
      </ul>
    </div>
  );
}

export default DownloadButton;
